import axios from "axios";

export class BigTitleAPI {
	static async fetch() {
		return (await axios.get(`${process.env.REACT_APP_BASE_URL}/api/big-title/`)).data.data.attributes.text;
	}
}
